import Image from "next/image";
import styles from './trendsBlog.module.css';
import { Lead } from '../../shared/lead/Lead';
import { LeadPopUpButton } from "@/components/shared/lead/LeadPopUpButton";
import { CountryCode, ElemenetType, ModuleType } from '@/lib/constants';
import { NavLink } from '../../ui';
import { IBlogs, IDiWidget, IHomeData, IRelatedCat } from '@/interfaces';
import { TrendsLongBody } from "../../longBody/trendsLongBody";
import { cmsLoader, staticLoader } from "../../../lib/helpers/imageLoader";
import { formatDate, pushRoute } from "../../../lib/helpers/common";
import { DesignWidget } from "@/components/designCategory/DesignWidget";
import { TrendsWidget } from "@/components/shared/widgets/trendsWidget";
import { TrendsBlogToc } from "../trendsBlogToc";
import { CtaToast } from "../ctaToast";
import { TrendsBlogsCta } from "../trendsBlogCta";
import { BlogCalculatorCta } from "../blogCalculatorCta";
import { useGlobalContext } from "@/lib/context";
import { useEffect, useState } from "react";
import ReactDOMServer from 'react-dom/server';
import { TrendsSearchBar } from "../trendsSearchBar";
import { TrendsDiCatCta } from "../trendsDiCatCta";
type props = {
    blogData: IBlogs[];
    countryCode: CountryCode,
    blogCats: IHomeData[],
    filterWidget: IDiWidget,
    relatedCatPosts: IRelatedCat[]
}
export function Trendsblog({ blogData, countryCode, blogCats, filterWidget, relatedCatPosts }: props) {
    const siteURL = process.env.SITE_URL + "/" + countryCode;
    const { props: { isMobileView } } = useGlobalContext();
    const postContent = (blogData[0] && blogData[0].post_content.replaceAll('https://cms.interiorcompany.com/cdn-cgi/image/quality=70,fit=crop,gravity=auto,format=webp/', 'https://cms.interiorcompany.com/')) || "";
    const [modifiedContent, setModifiedContent] = useState(postContent);

    const regex = /\{([^}]+)\}/g;
    const replacedString = postContent.replaceAll(regex, (match, componentName) => {
        if (componentName) {
            return ReactDOMServer.renderToString(<TrendsDiCatCta bannerType={componentName} />);
        } else {
            return match;
        }
    });
    useEffect(() => {
        if (postContent) {
            const myComponentHTML = ReactDOMServer.renderToString(<TrendsBlogsCta />);
            const myComponentHTMLCalc = ReactDOMServer.renderToString(<BlogCalculatorCta />);
            setModifiedContent((replacedString.replaceAll(('<div class="blogCtaLeadForm"></div>' || '<div class="blogCtaLeadForm"> </div>'), myComponentHTML).replaceAll(('<div class="blogCtaCalc"></div>' || '<div class="blogCtaCalc"> </div>'), myComponentHTMLCalc)))
        }
    }, [postContent]);
    return (
        <div className='container'>
            <div className={`${styles.trendsBlogSectn} trend-${blogData[0].post_id}`}>
                <div className={styles.trendsSec} >
                    <div className={styles.trendsBlog}>
                        <div className="blogCtaLead"></div>
                        {isMobileView &&
                            <>
                                <div className="ctaToastBoxUpper">
                                    <CtaToast />
                                </div>
                                <TrendsSearchBar />
                            </>
                        }
                        <h1 className={styles.mainHeading}>{blogData[0].post_title}</h1>
                        <div className="publisOn mb10"><span className="text666 font12 fbold "> {blogData[0].post_updated_date === blogData[0].post_date ? `Published On: ${formatDate(blogData[0].post_date)}` : `Updated On: ${formatDate(blogData[0].post_updated_date)}`}</span></div>
                        <div className={styles.blogUser}>
                            {blogData[0].author_relative ? <figure>
                                <Image
                                    src={blogData[0].author_relative}
                                    height={37}
                                    width={37}
                                    alt="blogUser"
                                    loader={cmsLoader}
                                    className="img-responsive"
                                />
                            </figure> : null}
                            <NavLink href={`${siteURL}/trends/author/${blogData[0].autho_slug}`}><div className={styles.userDetail}>
                                <label>{blogData[0].author_name}</label>
                                <div className="otherDetails"><span className="font10 text666">{blogData[0].postCount} Stories</span></div>
                            </div></NavLink>
                        </div>
                        <section>
                            <div className={styles.blogDetails} dangerouslySetInnerHTML={{ __html: blogData[0].short_paragraph }}></div>
                            <TrendsBlogToc toc={blogData[0].toc} />
                            <div className={styles.blogDetails} dangerouslySetInnerHTML={{ __html: modifiedContent }}></div>
                        </section>
                        <DesignWidget widgetData={filterWidget} />
                    </div>
                </div>
                {isMobileView && blogData && blogData[0] && blogData[0].Post_faq && blogData[0].Post_faq.FAQ && blogData[0].Post_faq.FAQ.length > 0 ? <TrendsLongBody faqData={blogData[0].Post_faq} /> : null}
                {isMobileView && <TrendsWidget relatedCat={relatedCatPosts} />}
                <div className={styles.formAndTopics}>
                    {!isMobileView && <TrendsSearchBar />}
                    <div className={styles.blogCtaBox}>
                        <h3 className={styles.title}>Ready for a home transformation?<br />Let our designers assist you!</h3>
                        {isMobileView ? <button className={`btn font14 ctaForm`} >Book Free Consultation</button> :
                            <LeadPopUpButton ElemenetType={ElemenetType.button} ButtonClass={`btn font14`} />}
                    </div>
                    <div className={`${styles.recntBlogpost} mb46`}>
                        <h3 className="font16 text222 fbold">Recent Posts</h3>
                        {blogData[0].related_post.filter((f: any) => f.post_relative).map((relatedPosts: IBlogs, index: number) =>
                            <div className={`${styles.rectTilesblod} trend-${relatedPosts.post_id}`} key={index} onClick={() => pushRoute(siteURL + "/trends/" + relatedPosts.parmalink)}>
                                <div className={styles.vlogImgbox}><Image
                                    src={relatedPosts.post_relative}
                                    height={70}
                                    width={75}
                                    loader={cmsLoader}
                                    alt={relatedPosts.post_title}
                                /></div>
                                <div className={styles.vlogBoxtext}>
                                    <NavLink href={siteURL + "/trends/" + relatedPosts.parmalink}> <p className="font14 text222 lineHeight20 ">{relatedPosts.post_title}</p></NavLink>
                                    <label className="font12 text666" style={{ cursor: 'pointer' }}>{formatDate(relatedPosts.post_updated_date === relatedPosts.post_date ? relatedPosts.post_date : relatedPosts.post_updated_date)}</label>
                                </div>
                            </div>)}
                    </div>
                    <div className={styles.rectBlogdowntiles}>
                        <h3 className="font16 text222 fbold mb10">Popular Categories</h3>
                        {blogCats && blogCats.map((popularCats: any, index: number) =>
                            <div className={styles.tarndVlogerlowertil} key={index} onClick={() => pushRoute(`${siteURL}/trends/${popularCats.cat_url}`)}>
                                <div className={styles.tarndimgTextbox}>
                                    <span>
                                        <Image
                                            src={popularCats.cat_relative}
                                            height={24}
                                            loader={cmsLoader}
                                            width={24}
                                            alt={popularCats.cat_name} />
                                    </span>
                                    <NavLink href={`${siteURL}/trends/${popularCats.cat_url}`}> <p>{popularCats.cat_name}</p>  </NavLink>
                                </div>
                                <div className="trandNubrtex">
                                    <p>{popularCats.post_count}</p>
                                </div>
                            </div>

                        )}
                    </div>
                    <div className={`formBox bgWhite ${styles.blogForm}`}>
                        <Lead ModuleType={ModuleType.INTERIOR} Title="Meet the Designer" ButtonText="Book Free Consultation" />
                    </div>
                </div>
            </div>
            {!isMobileView && blogData && blogData[0] && blogData[0].Post_faq && blogData[0].Post_faq.FAQ && blogData[0].Post_faq.FAQ.length > 0 ? <TrendsLongBody faqData={blogData[0].Post_faq} /> : null}
            {!isMobileView && <TrendsWidget relatedCat={relatedCatPosts} />}
        </div>
    );
}